import api from "@/lib/api";

// Member-to-member: internal prefix on the softswitch (or plain on-net). External: LCR prefix.
export async function routeDestination(number) {
  try {
    const { data } = await api.get(`/calling/sip-trunk?number=${encodeURIComponent(number)}`);
    const t = data?.trunk;
    if (!t?.host) return number;
    if (data.internal && !t.internal_prefix) return number;
    const digits = String(number).replace(/\D/g, "");
    const prefix = data.internal ? t.internal_prefix : (t.prefix || "");
    return `sip:${prefix}${digits}@${t.host}${t.port ? `:${t.port}` : ""}`;
  } catch {
    return number;
  }
}
